import './BetbookFilterTags.less';

import clsx from 'clsx';
import React, { memo } from 'react';
import i18n from '../../../common/i18n';

import { BETTABLE, TIME_3HOURS, TIME_TODAY, TIME_TOMORROW } from '../constants';

const BetbookFilterTags = memo(({ className, onTagChange, selectedTag }) => {
    function onClick(e) {
        const tag = e.currentTarget.value;
        onTagChange(selectedTag === tag ? undefined : tag);
    }
    return (
        <div className={clsx('betbook-filter-tags', className)}>
            <button
                className={clsx('betbook-filter-button br-default', { active: selectedTag === TIME_3HOURS })}
                data-atid="betbook-filter-3hours"
                onClick={onClick}
                value={TIME_3HOURS}
            >
                {i18n('nui.betbook.filters.display.3hours')}
            </button>
            <button
                className={clsx('betbook-filter-button br-default', { active: selectedTag === TIME_TODAY })}
                data-atid="betbook-filter-today"
                onClick={onClick}
                value={TIME_TODAY}
            >
                {i18n('nui.betbook.filters.display.today')}
            </button>
            <button
                className={clsx('betbook-filter-button br-default', { active: selectedTag === TIME_TOMORROW })}
                data-atid="betbook-filter-tomorrow"
                onClick={onClick}
                value={TIME_TOMORROW}
            >
                {i18n('nui.betbook.filters.display.tomorrow')}
            </button>
            <button
                className={clsx('betbook-filter-button br-default', { active: selectedTag === BETTABLE })}
                data-atid="betbook-filter-bettable"
                onClick={onClick}
                value={BETTABLE}
            >
                {i18n('nui.betbook.filters.display.bettable')}
            </button>
        </div>
    );
});

export default BetbookFilterTags;
